import { isSuperAdmin, setUserToken } from "@/helpers";
import React, { lazy, Suspense, useLayoutEffect } from "react";
import { Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";
import Footer from "./Footer";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import {
  getTimeZoneList,
  getUserProfile,
  logout,
  updateProfile,
  logoutApi
} from "@/services";
import TimezoneModal from "../TimezoneModal";
import BroadcastMessageWrapper from "../Broadcast/BroadcastMessageWrapper";
import { resetBroadcast } from "@/reducers/broadcast";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./topbar.css";
import "../../index.css";
import { useLocation } from "react-router-dom";
const SideNav = lazy(() => import("./SideNav"));

function DefaultLayout(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const pathname = location.pathname;
  const {
    dashboardLoader: dashboardLoading,
    timeZoneList,
    user: userData,
  } = useSelector((state) => state.auth);
  const parentCategories = useSelector((state) => state.equipment.parentCategories)
  const equipmentCategories = useSelector((state) => state.equipment.equipmentCategories)
  const [state, setState] = useState({});
  const { timeZone, showTimeZoneModal } = state;
  const isCurriculum = pathname.includes("curriculum");

  const toggleSideNav = (e) => {
    let el = document.getElementById("sideNav");
    e?.target.checked
      ? el.classList.remove("sideNav", "isSearchNav")
      : el.classList.add("sideNav", `${props.isSearch && "isSearchNav"}`);

    if (props.isSearch) {
      let content = document.getElementById("content");
      e?.target.checked
        ? content.classList.replace("fullBody", "body")
        : content.classList.replace("body", "fullBody");
    }
  };

  useEffect(() => {
  setState((prev) => ({
    ...prev,
    showTimeZoneModal: userData?.timezone_id === null,
  }));

  if (!timeZoneList && !isCurriculum) {
    dispatch(getTimeZoneList());
  }
}, [dispatch, userData?.timezone_id, timeZoneList, isCurriculum]);

 useEffect(() => {
  if (pathname.includes("/curriculum/")) {
    let content = document.getElementById("content");
    content.classList.replace("body", "curriculumBody");
  }

  if (pathname.includes("curriculum")) {
    const styleElement = document.createElement("style");
    styleElement.innerHTML =
      "body::-webkit-scrollbar-thumb { background: var(--primary-color); }";

    document.head.appendChild(styleElement);

    document.body.classList.add("curr");

    return () => {
      document.head.removeChild(styleElement);
    };
  }
}, [pathname]);
  useLayoutEffect(() => {
  const shouldBounce =
    equipmentCategories !== null &&
    !userData?.timezone_id &&
    !parentCategories?.includes("curriculum") &&
    pathname.includes("curriculum");
  if (shouldBounce) {
    setTimeout(() => {
      navigate("/dashboard");
    }, 0);
  }
}, [userData?.timezone_id, parentCategories, equipmentCategories, pathname, navigate]);

  const handleChange = (value) => {
    setState((prev)=>({...prev, timeZone: value }));
  };
  const handleSubmit = () => {
    const payload = {
      timezone_id: timeZone?.id,
    };
    if (timeZone?.id) {
      dispatch(updateProfile(payload))
        .unwrap()
        .then((res) => {
          if (res?.success) {
            toast.success(res?.message);
            dispatch(getUserProfile());
            let token = JSON.parse(localStorage.getItem("token"));
            token.user = res;
            setUserToken(token);
            setState((prev)=>({...prev, showTimeZoneModal: false }));
          }
        });
    } else {
      toast.error("Please select timezone");
    }
  };
  const handleLogout = (e) => {
    e.preventDefault();
    logout();
    dispatch(logoutApi());
    // Clear the broadcast queue so the next logged-in user fetches their own.
    dispatch(resetBroadcast());
    return navigate("/", { replace: true });
  };
  return (
    <>
      <Suspense>
        <SideNav isSearch={props.isSearch} toggleSideNav={toggleSideNav} />
      </Suspense>
      <div className="wrapper d-flex flex-column flex-grow-1 ">
        <div
          style={{ position: "relative" }}
          className={`${props.isSearch ? "fullBody" : "body"} ${isSuperAdmin() ? "mt-5" : "mt-0"
            } flex-grow-1 px-3 pb-5 d-flex flex-column mt-sm-0 curriculum_outer ${window.location.pathname.includes("curriculum") ? "pe-0" : "px-3"
            }`}
          id="content"
        >
          {props.children}
          {dashboardLoading && (
            <div style={{ position: "fixed", top: "48%", left: "49%" }}>
              <Spinner
                animation="border"
                className="d-flex align-self-center"
              />
            </div>
          )}
        </div>
        {window.location.pathname.includes("curriculum") ? "" : <Footer />}
        {
          <TimezoneModal
            showTimeZoneModal={showTimeZoneModal}
            moduleName={"Timezone"}
            handleChange={handleChange}
            data={timeZoneList}
            value={timeZone}
            handleSubmit={handleSubmit}
            handleLogout={handleLogout}
          />
        }
        <BroadcastMessageWrapper />
      </div>
    </>
  );
}

export default DefaultLayout;
